<template>
    <ui-modal small>
        <template #header>
            <h3 v-text="title" class="mb-1 text-center" />
        </template>
        <page-preloader v-if="loader" min-height="5rem" />
        <div v-else class="d-flex flex-column gap-1 align-items-center text-primary">
            <div v-text="confirmationText" />
            <div
                v-if="modalArgs.userAlias || modalArgs.login"
                v-text="`${modalArgs.userAlias} ${modalArgs.login}`"
            />
            <div v-text="warningText" />
        </div>
        <template #footer>
            <the-btn
                class="btn-outline-custom"
                text="Zamknij"
                @click="closeModal"
            />
            <the-btn
                class="btn-danger"
                text="Dezaktywuj"
                :disabled="loader"
                @click="deactivate"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data: () => ({
        loader: false
    }),
    provide() {
        return {
            closeModal: this.closeModal
        }
    },
    computed: {
        modalArgs() {
            return this.$store.getters.modalState.args
        },
        isApplication() {
            return this.modalArgs.isApplication
        },
        title() {
            return this.isApplication ? 'Dezaktywacja konta' : 'Dezaktywacja urządzenia'
        },
        confirmationText() {
            return `Czy na pewno chcesz dezaktywować ${this.isApplication ? 'konto' : 'urządzenie'}?`
        },
        warningText() {
            return this.isApplication
                ? 'Użytkownik straci dostęp do aplikacji mobilnej.'
                : 'Operacji nie można odwrócić.'
        }
    },
    methods: {
        ...mapActions('drsLicenses', ['deactivateLicense', 'fetchDevices']),
        closeModal() {
            this.$emit('close')
            this.$store.dispatch('openModal', {
                componentPath: 'drs/stores/licenses/LicenseForm',
                args: { ...this.modalArgs.licenseFormModalArgs }
            })
        },
        async deactivate () {
            try {
                this.loader = true
                await this.deactivateLicense({
                    devices: [{
                        id: this.modalArgs.licenseFormModalArgs.license.terminal_id,
                        state_code: 'INNACTIVE'
                    }]
                })
            } finally {
                this.loader = false
                this.fetchDevices(this.modalArgs.locationId)
                this.$store.dispatch('toggleModal', false)
            }
        }
    }
}
</script>